import { FC, useContext } from 'react';
import { Menu, Spinner } from '@chakra-ui/react';

import { useRunCreditSenseRequest } from '~/core/shared/api/plugin';
import { useEventHandler } from '~/core/shared/hooks/useEventHandler';
import {
  ApplicationContext,
  DocumentDetailsViewActionContext,
} from '../Layout.component';

export const CreditSenseMenuItem: FC = () => {
  const { runCreditSenseRequest, isPending } = useRunCreditSenseRequest();
  const { applicationUuid } = useContext(ApplicationContext);

  const {
    action: { text },
  } = useContext(DocumentDetailsViewActionContext);

  const handleRunCreditSenseRequest = useEventHandler(
    async (): Promise<void> => {
      try {
        await runCreditSenseRequest({ params: { id: applicationUuid } });
      } catch (error) {
        console.error(error);
        // Error is handled in useRunCreditSenseRequest
      }
    },
  );

  return (
    <Menu.Item onClick={handleRunCreditSenseRequest} value="credit-sense">
      {isPending && <Spinner size="xs" />}
      {text}
    </Menu.Item>
  );
};
